import { useTranslation } from 'react-i18next';
import styles from './FooterDesktop.module.css';
import footerImagesInfo from '../../../assets/footerInfo/footerImgs';
import { motion, AnimatePresence } from 'framer-motion';
import InstagramFooterIconDesktop from '../../Icons/InstagramFooterIconDesktop';

const FooterDesktop = () => {
  const { t } = useTranslation();

  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);
  return (
    <footer className={styles.footerDesktopContainer} role='contentinfo'>
      <h2 className={styles.title}>{t('lang.footerTitle')}</h2>

      <div className={styles.imagesContainer}>
        <a
          className={styles.facebookIcon}
          target='_blank'
          rel='noreferrer'
          href='https://www.instagram.com/vikyvivavi/'
          // href="https://www.facebook.com/viktoriia.perfilieva"
        >
          {/* <FacebookFooterIcon /> */}
          <InstagramFooterIconDesktop />
        </a>

        <AnimatePresence>
          {footerImagesInfo?.map((item, idx) => (
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              exit={{ opacity: 0, y: 30 }}
              className={styles.imageWrap}
              key={idx}
            >
              <div className={styles.imageMask}></div>
              <img className={styles.image} src={item.link} alt={item.alter} />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </footer>
  );
};

export default FooterDesktop;
